import { PlanGenPhase } from './types'

/**
 * Whether a phase change is the moment a plan finished — the edge a toast should announce.
 *
 * `phase` is a standing condition derived from backend state, not an event: `Ready` stays true
 * from the moment the plan lands until the draft is finalized, which can be days. Announcing the
 * condition means re-announcing on every reload, tab and sign-in, so announce the transition into
 * it instead. Only a phase arriving FROM `Processing` counts: a page that loads straight into
 * `Ready` never saw the plan finish, and its user has the nav pill instead.
 */
export function isOutcomeEdge(previous: PlanGenPhase | null, next: PlanGenPhase): boolean {
  if (previous !== PlanGenPhase.Processing) return false
  return next === PlanGenPhase.Ready || next === PlanGenPhase.Failed
}
